export default function getPasswordFormat() {
  return fetch(`${window.graphqlEndpoint}/auth/password_format`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((response) => response.json())
}
